import AppCustom from './components/AppCustom';
import AppControl from './components/AppControl';
import { useGlobal } from '@/utils/useGlobal';
import AppPointDeltaAdv from '@/components/AppPoint/DeltaAdvPC';
import { SHOW_APP_POINT_SITES } from '@/constants';

export default function AnimationK() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const sites = ['fr', 'de', 'it', 'es', 'jp', 'sa'];

    if (sites.includes(locale)) {
        return <AppCustom />;
    } else if (SHOW_APP_POINT_SITES.includes(locale)) {
        return <AppPointDeltaAdv />;
    } else {
        return <AppControl />;
    }
}
